export default __webpack_public_path__ + "static/gallery19-7b8d3d537bd098570da519ab15d3bb6f.png";